import { DefaultLayout } from "layouts/default";
import { Fragment } from "react";
import { useRoutes } from "react-router-dom";
import type { BreadcrumbsRoute } from "use-react-router-breadcrumbs";
import { DefaultProjectPage } from "pages/project/default";
import { ProjectsPage } from "pages/Projects";
import { PrintLayout } from "layouts/print-layout";
import { DefaultProjectPrintReportPage } from "components/page/projects/dashboard/reports/print-reports/default";
import { LandingPageInvites } from "pages/LandingPageInvites";
import { useInvitationRedirectIfAny } from "utils/storage/storage";
import { Admin } from "pages/admin/Admin";
import { DefaultAccountPage } from "pages/account/default";
import { AccountPage } from "pages/Account";

export const routes: BreadcrumbsRoute[] = [
  {
    path: "/projectlist",
    element: <DefaultLayout />,

    children: [
      {
        path: "",
        element: <ProjectsPage selectLastUsedProject={false} />,
      },
    ],
  },
  {
    path: "/admin",
    element: <DefaultLayout />,

    children: [
      {
        path: "",
        element: <Admin />,
      },
    ],
  },
  {
    path: "/account",
    element: <DefaultLayout />,

    children: [
      {
        path: "",
        element: <AccountPage />,
      },
      {
        path: "notifications",
        element: <DefaultAccountPage subPage="notifications" />,
      },
      {
        path: "profile",
        element: <DefaultAccountPage subPage="profile" />,
      },
      {
        path: "admin",
        element: <DefaultAccountPage subPage="admin" />,
      },
      {
        path: "information",
        element: <DefaultAccountPage subPage="information" />,
      },
      {
        path: "favorites",
        element: <DefaultAccountPage subPage="favorites" />,
      },
      {
        path: "projects",
        element: <DefaultAccountPage subPage="projects" />,
      },
    ],
  },
  {
    path: "/reports/projects",
    element: <PrintLayout />,
    children: [{ path: ":projectId/projectinfo/", element: <DefaultProjectPrintReportPage subPage="projekt-info" /> }],
  },
  {
    path: "/projects",
    element: <DefaultLayout />,
    children: [
      {
        path: "",
        element: <ProjectsPage selectLastUsedProject={true} />,
      },
      {
        path: ":projectId",
        element: <DefaultProjectPage subPage="folders" />,
      },
      {
        path: ":projectId/dashboard/",
        element: <DefaultProjectPage subPage="dashboard" />,
      },
      {
        path: ":projectId/dashboard/favorites/",
        element: <DefaultProjectPage subPage="dashboard-favorites" />,
      },
      {
        path: ":projectId/dashboard/compensation-payment/",
        element: <DefaultProjectPage subPage="dashboard-compensation-payment" />,
      },
      {
        path: ":projectId/dashboard/extraworkagreements/",
        element: <DefaultProjectPage subPage="dashboard-extra-work-agreements" />,
      },
      {
        path: ":projectId/dashboard/extraworkagreements/create",
        element: <DefaultProjectPage subPage="dashboard-extra-work-agreements-edit" />,
      },
      {
        path: ":projectId/dashboard/extraworkagreements/:extraworkAgreementId",
        element: <DefaultProjectPage subPage="dashboard-extra-work-agreements-edit" />,
      },

      {
        path: ":projectId/dashboard/project-info/",
        element: <DefaultProjectPage subPage="dashboard-project-info" />,
      },
      {
        path: ":projectId/dashboard/calculation/",
        element: <DefaultProjectPage subPage="dashboard-calculation" />,
      },
      {
        path: ":projectId/dashboard/reports/",
        element: <DefaultProjectPage subPage="dashboard-reports" />,
      },
      {
        path: ":projectId/dashboard/users/",
        element: <DefaultProjectPage subPage="dashboard-users" />,
      },
      {
        path: ":projectId/dashboard/projectspecificoperations",
        element: <DefaultProjectPage subPage="dashboard-project-specific-operations" />,
      },
      {
        path: ":projectId/logbook/",
        element: <DefaultProjectPage subPage="logbook" />,
      },
      {
        path: ":projectId/draft/",
        element: <DefaultProjectPage subPage="draft" />,
      },
      {
        path: ":projectId/folders/:folderId",
        element: <DefaultProjectPage subPage="folders" />,
      },
      {
        path: ":projectId/folders/:folderId/foldercontent",
        element: <DefaultProjectPage subPage="foldercontent" />,
      },
    ],
  },
  {
    path: "/verifyInvitation/*",
    element: <LandingPageInvites />,
  },
  {
    path: "*",
    element: <DefaultLayout />,

    children: [
      {
        path: "*",
        element: <ProjectsPage selectLastUsedProject={true} />,
      },
    ],
  },
];

export function AppRoutes() {
  let routeElement = useRoutes(routes);
  useInvitationRedirectIfAny();
  return <Fragment>{routeElement}</Fragment>;
}
